import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from '../spzaComponent';
export const SortOrder = {
    None: 'none',
    Ascending: 'ascending',
    Descending: 'descending'
};
export const SortOrderStyles = {
    NoneStyle: 'c-glyph',
    AscendingStyle: 'c-glyph f-ascending',
    DescendingStyle: 'c-glyph f-descending'
};
export class SortedTH extends SpzaComponent {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.boundProperty !== nextProps.currentlySelected) {
            this.setState({
                ariaSort: SortOrder.None,
                buttonClass: SortOrderStyles.NoneStyle
            });
        }
    }
    handleHeaderClick() {
        let newState = {
            ariaSort: SortOrder.None,
            buttonClass: SortOrderStyles.NoneStyle
        };
        if (this.state.ariaSort === SortOrder.None || this.state.ariaSort === SortOrder.Descending) {
            newState = {
                ariaSort: SortOrder.Ascending,
                buttonClass: SortOrderStyles.AscendingStyle
            };
        } else {
            newState = {
                ariaSort: SortOrder.Descending,
                buttonClass: SortOrderStyles.DescendingStyle
            };
        }
        this.setState(newState);
        this.props.handleSortChange(this.props.boundProperty, newState.ariaSort);
    }
    renderImpl() {
        return /*#__PURE__*/ _jsx("th", {
            scope: "col",
            className: "f-sortable",
            "aria-sort": this.state.ariaSort,
            children: /*#__PURE__*/ _jsx("button", {
                className: this.state.buttonClass,
                "aria-pressed": "mixed",
                "aria-label": `${this.props.children} current sorting mode is ${this.state.ariaSort}`,
                onClick: ()=>this.handleHeaderClick(),
                children: this.props.children
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            ariaSort: SortOrder.None,
            buttonClass: SortOrderStyles.NoneStyle
        };
    }
}
